var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column-full"},[_c('div',{staticClass:"content loader-wrapper"},[_c('default-loader')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }